import Persistable from "../../../storage/persistable";
import FragmentSummary from "./fragment-summary";
import { isDefined } from "../../../services/common/object-util";

export default class Fragment extends Persistable {
    constructor(requiredData = []) {
        super();
        this.requiredData = requiredData;
    }

    summarize(summaryContext) {
        return new FragmentSummary(this.constructor.name);
    }

    setPlay(play) {
        this.playId = play.id;
    }

    onBuild(playData) {}

    requiresData() {
        return this.requiredData.filter((rd) => !rd.optional).length > 0;
    }

    // The optional `play` flows through to per-field callbacks (isSkipped)
    // so a field's applicability can be derived from the play history at
    // call time instead of being stamped on the fragment.
    hasRequiredPartialData(play) {
        let isComplete = true;
        var self = this;
        this.requiredData
            .filter((rd) => {
                // Exclude items where isSkipped returns true
                if (rd.isSkipped && rd.isSkipped(play)) return false;
                // Include non-optional items, or optional items with explicit isSkipped=false
                return !rd.optional || (rd.isSkipped && !rd.isSkipped(play));
            })
            .forEach((rd) => {
                const value = self[rd.name];
                if (
                    !rd.requiredAfterNextState &&
                    (!isDefined(value) ||
                        (Array.isArray(value) && !value.length))
                ) {
                    isComplete = false;
                }
            });

        return isComplete;
    }

    hasRequiredData(play) {
        let isComplete = true;
        this.requiredData
            .filter((rd) => {
                // Exclude items where isSkipped returns true
                if (rd.isSkipped && rd.isSkipped(play)) return false;
                return !rd.optional;
            })
            .forEach((rd) => {
                if (this[rd.name] === undefined) {
                    isComplete = false;
                }
            });

        return isComplete;
    }

    changesPossession() {
        return false;
    }

    dirtiesPlaySequence() {
        return false;
    }

    toJSON(includedProps = [], excludedProps = ["requiredData"]) {
        return super.toJSON(includedProps, excludedProps);
    }

    equals(fragment) {
        if (this.id && fragment.id) {
            return this.id === fragment.id;
        }

        return (
            this.playId === fragment.playId &&
            this.associatedState === fragment.associatedState &&
            this.associatedHistoryIndex === fragment.associatedHistoryIndex
        );
    }

    getFieldPosition() {
        return null;
    }

    getFragmentTeamId(nextFragment) {
        return null;
    }

    updateSummaryContext(summaryContext) {}

    getPlayers() {
        return [];
    }

    isEditable() {
        return this.requiredData?.some((rd) => rd.isEditable);
    }

    getScoringPoints() {
        return 0;
    }

    excludeRequiredData() {
        return false;
    }

    getTimeAndPeriod() {
        return null;
    }

    isOptional(name) {
        return this.requiredData.find((rd) => rd.name === name)?.optional;
    }

    isDataComplete(name, play) {
        let complete = true;
        const rd = this.requiredData.find((r) => r.name === name);
        if (rd) {
            // If isSkipped returns true, data is considered complete
            if (rd.isSkipped && rd.isSkipped(play)) {
                return true;
            }
            if (Array.isArray(this[name])) {
                complete = this[name].length > 0;
            } else {
                complete = this[name] !== undefined;
            }
        }

        return complete;
    }
}
